import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { getMasterSystem } from "@/services/getData"
import { useState } from "react"
import { useQuery } from "@tanstack/react-query"
import { useNavigate, useSearchParams } from "react-router-dom"
import { BarChartComponent } from "./partial/BarChart"
import TabelRekap from "./partial/TabelRekap"
// import TableRekapPenerimaan from "./partial/TableRekapPenerimaan"
// import { AreaChartComponent } from "./partial/AreaChart";

export default function DashboardAkademikPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const menuParams = searchParams.get("menu") || "GRAFIK"
  const submenuParams = searchParams.get("submenu") || "DAFTARKEMBALI"

  const [activeMenu, setActiveMenu] = useState<"GRAFIK" | "DATA">(
    menuParams as "GRAFIK" | "DATA"
  )
  const [activeSubmenu, setActiveSubmenu] = useState<
    "DAFTARKEMBALI" | "PENERIMAAN"
  >(submenuParams as "DAFTARKEMBALI" | "PENERIMAAN")

  const { data: system } = useQuery({
    queryKey: ["masterSystem"],
    queryFn: getMasterSystem,
  })

  return (
    <div>
      <h1 className="mb-5 text-2xl font-bold">Dashboard</h1>
      <section className="mb-3 grid grid-cols-2 gap-3">
        <Card
          className={`${
            activeMenu === "GRAFIK"
              ? "bg-primary text-white"
              : "cursor-pointer hover:bg-secondary"
          }`}
          onClick={() => {
            setActiveMenu("GRAFIK")
            searchParams.set("menu", "GRAFIK")
            navigate(`/akademik/dashboard?${searchParams.toString()}`)
          }}
        >
          <CardHeader>
            <CardTitle>Grafik</CardTitle>
            <CardDescription
              className={`${
                activeMenu === "GRAFIK" ? "text-muted" : "text-muted-foreground"
              } `}
            >
              Tahun {system ? system[0]?.tahun_aktif : "-"}
            </CardDescription>
          </CardHeader>
        </Card>
        <Card
          className={`${
            activeMenu === "DATA"
              ? "bg-black/90 text-white"
              : "cursor-pointer hover:bg-secondary"
          }`}
          onClick={() => {
            setActiveMenu("DATA")
            searchParams.set("menu", "DATA")
            navigate(`/akademik/dashboard?${searchParams.toString()}`)
          }}
        >
          <CardHeader>
            <CardTitle>Data</CardTitle>
            <CardDescription
              className={`${
                activeMenu === "DATA" ? "text-muted" : "text-muted-foreground"
              } `}
            >
              Tahun {system ? system[0]?.tahun_aktif : "-"}
            </CardDescription>
          </CardHeader>
        </Card>
      </section>
      {activeMenu === "GRAFIK" && (
        <section>
          <div className="mb-3 grid grid-cols-2 gap-3">
            {/* <AreaChartComponent /> */}
          </div>

          <BarChartComponent
            tahun={system ? system[0]?.tahun_aktif : new Date().getFullYear()}
          />
        </section>
      )}

      {activeMenu === "DATA" && (
        <div>
          <div className="mb-5 w-fit rounded-full overflow-hidden border flex">
            <button
              className={`py-2 px-4 rounded-full ${
                activeSubmenu === "DAFTARKEMBALI"
                  ? "bg-black/90 text-white"
                  : "hover:bg-secondary"
              }`}
              onClick={() => {
                setActiveSubmenu("DAFTARKEMBALI")
                searchParams.set("submenu", "DAFTARKEMBALI")
                navigate(`/akademik/dashboard?${searchParams.toString()}`)
              }}
            >
              Rekap Daftarkembali
            </button>
            {/* <button
              className={`py-2 px-4 rounded-full ${
                activeSubmenu === "PENERIMAAN"
                  ? "bg-black/90 text-white"
                  : "hover:bg-secondary"
              }`}
              onClick={() => {
                setActiveSubmenu("PENERIMAAN")
                searchParams.set("submenu", "PENERIMAAN")
                navigate(`/akademik/dashboard?${searchParams.toString()}`)
              }}
            >
              Rekap Penerimaan
            </button> */}
          </div>
          {activeSubmenu == "DAFTARKEMBALI" && <TabelRekap />}
          {/* {activeSubmenu == "PENERIMAAN" && <TableRekapPenerimaan />} */}
        </div>
      )}
    </div>
  )
}
